// extracted by mini-css-extract-plugin
export default {"root":"styles_root__g-aMJ","option":"styles_option__0-81k","inputWrapper":"styles_inputWrapper__Okoxo","label":"styles_label__x8hsU"};